goog.provide('el8.core.uiwidget.SubmenuGroup');
goog.provide('el8.core.uiwidget.Submenu');

/**
 * This widget was basically built to manage the dropdowns for the
 * chart write-see bar and header dropdowns (I need help, etc.).
 *
 * In more generic terms, it's a wrapper around jqModal for managing
 * a set of related dropdowns where the dropdowns are pre-built (or
 * externally built) HTML, unlike NewActionsMenu, which builds its
 * dropdowns on the fly via JS.
 */
el8.core.uiwidget.SubmenuGroup = function() {
    this._allSubmenus = [];
};

el8.core.uiwidget.SubmenuGroup.prototype.hideAll = function() {
    this._allSubmenus.map(function(sm) { sm.hide(); });
};

el8.core.uiwidget.SubmenuGroup.prototype.addSubmenu = function(spec) {
    var submenu = new el8.core.uiwidget.Submenu(spec, this);
    this._allSubmenus.push(submenu);
};


/**
 * A SubmenuGroup is a list of Submenus
 */
el8.core.uiwidget.Submenu = function(spec, group) {

    var trigger = spec.trigger;
    var menu = spec.menu;
    var topOffset = spec.top || 0;
    var leftOffset = spec.left || 0;
    // apply this class to the trigger when the menu is open; remove it whe nclosed
    var triggerSelectedClass = spec.triggerSelectedClass || null;

    var that = this;
    var hideModalFn = function(event) {
        that.hide();
        return true;
    };

    menu.jqm({
        modal: false,
        // This adds a transparent overlay to the page, which helps make sure that clicking anywhere
        // (including another trigger for a jqModal) will close this menu. Unfortunately, it also
        // means that we need two clicks to switch from one Submenu trigger to another (one to close
        // the overlay and a second to open the menu)
        overlay: 0.1,
        onHide: function(hash) {
            // See http://jquery.iceburg.net/jqModal/ for details on `hash`. The short version:
            //
            // hash object:
            //  w: (jQuery object) The modal element
            //  c: (object) The modal's options object
            //  o: (jQuery object) The overlay element
            //  t: (DOM object) The triggering element
            hash.w.hide();
            if (hash.o) { hash.o.remove(); }
            if (triggerSelectedClass) { trigger.removeClass(triggerSelectedClass); }
            $(document).unbind('click', hideModalFn);
        },
        onShow: function(hash) {
            // display the overlay (prepend to body) if not disabled
            if(hash.c.overlay) { hash.o.prependTo('body'); }

            hash.w.show();

            if (triggerSelectedClass) { trigger.addClass(triggerSelectedClass); }
            // This is necessary to make clicks in the menu themselves close the menu
            // (the overlay takes care of clicks outside the menu). If we get rid of the
            // overlay, click listeners that stop propagation (like actions menu buttons)
            // will not close the menu, but the overlay covers those up, making everything work.
            $(document).on('click', hideModalFn);
        }
    });

    this.show = function() {
        var _top = trigger.offset().top + topOffset;
        var _left = trigger.offset().left + leftOffset;

        menu.css('top', _top)
            .css('left', _left)
            .jqmShow();
    };
    this.hide = function() {
        menu.jqmHide();
    };

    trigger.on('click', function(event) {
        event.preventDefault();
        that.show();
        return false; // prevent hideModalFn from running immediately after showing the menu
    });

};
